import React from 'react';
import Section from './Section';

export default function Writing() {
    return (
        <Section id="writing" title="Writing">
            <article className="item">
                <h3 className="item-title">
                    <a href="#/blog/mehngai">
                        India’s inflation rate is a scraper problem
                    </a>
                </h3>
                <p className="item-text">
                    How Mehngai measured grocery inflation from four real
                    supermarket chains, and why the scrapers — not the index math
                    — were the hard part.
                </p>
                <p className="meta">August 2026 · scraping · data · Bright Data</p>
            </article>
            <article className="item">
                <h3 className="item-title">
                    <a href="#/blog/busfactor">
                        Your team&rsquo;s bus factor is a graph problem
                    </a>
                </h3>
                <p className="item-text">
                    How BusFactor turns ten years of git history into a
                    knowledge graph you can query, rehearse a departure on, and
                    heal &mdash; without ever touching the real data.
                </p>
                <p className="meta">October 2026 · graphs · FalkorDB · LLM systems</p>
            </article>
        </Section>
    );
}
